module.exports = __webpack_public_path__ + "static/media/correct_sound.8e3d6124.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/correct_sound.mp3
// module id = 1219
// module chunks = 2